var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDisconnectSGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H11V5.9H15C16.71 5.9 18.1 7.29 18.1 9C18.1 10.43 17.12 11.63 15.79 11.98L17.25 13.44C18.88 12.61 20 10.95 20 9C20 6.24 17.76 4 15 4ZM14 8H11.81L13.81 10H14V8ZM0 1.27L3.11 4.38C1.29 5.12 0 6.91 0 9C0 11.76 2.24 14 5 14H9V12.1H5C3.29 12.1 1.9 10.71 1.9 9C1.9 7.41 3.11 6.1 4.66 5.93L6.73 8H6V10H8.73L11 12.27V14H12.73L16.74 18L18 16.74L1.27 0L0 1.27Z",
    fill: "#3B2723"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisconnectSGrey);
export default __webpack_public_path__ + "static/media/icon-disconnect-s-grey.4ce327f5627c0e66c22c8bcc22186398.svg";
export { ForwardRef as ReactComponent };